import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import Papa from "papaparse";
import { Box, CircularProgress, Typography, Tabs, Tab } from "@mui/material";

export default function HistoricalWinners() {
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [years, setYears] = useState([]);
    const [selectedYear, setSelectedYear] = useState("");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const csvPath = "/static/csv/Winners-Historical-Data-2010-2025.csv";
        fetch(csvPath)
            .then((r) => r.text())
            .then((text) => {
                const parsed = Papa.parse(text, { header: true, skipEmptyLines: true });
                const data = parsed.data || [];
                if (data.length === 0) {
                    setColumns([]);
                    setRows([]);
                    setYears([]);
                    setSelectedYear("");
                    setLoading(false);
                    return;
                }
                const cols = Object.keys(data[0]).map((k) => {
                    const header = k.replace(/_/g, " ");
                    const width = /school\s*name/i.test(k) ? 320 : 160;
                    return { field: k, headerName: header, width };
                });
                const rowsWithId = data.map((r, idx) => ({ id: idx + 1, ...r }));
                // derive years and default to most recent
                const uniqueYears = Array.from(new Set(data.map((d) => d.Year).filter(Boolean))).sort((a, b) => Number(b) - Number(a));
                setColumns(cols);
                setRows(rowsWithId);
                setYears(uniqueYears);
                setSelectedYear(uniqueYears.length ? uniqueYears[0] : "");
                setLoading(false);
            })
            .catch((err) => {
                console.error("Failed to load CSV", err);
                setLoading(false);
            });
    }, []);

    if (loading) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", mt: 6 }}>
                <CircularProgress />
            </Box>
        );
    }

    if (!columns.length) {
        return (
            <Box sx={{ p: 4 }}>
                <Typography>No historical winner data found.</Typography>
            </Box>
        );
    }

    const displayedRows = rows.filter((r) => String(r.Year) === String(selectedYear));

    return (
        <Box sx={{ width: "100%", p: 2 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
                Historical Winners (2010–2025)
            </Typography>
            <Box sx={{ mb: 2 }}>
                <Tabs
                    value={selectedYear}
                    onChange={(e, v) => setSelectedYear(v)}
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="Years"
                >
                    {years.map((y) => (
                        <Tab key={y} label={y} value={y} />
                    ))}
                </Tabs>
            </Box>

            <DataGrid
                rows={displayedRows}
                columns={columns}
                autoHeight
                pagination={false}
                pageSizeOptions={[25, 50, 100]}
            />
        </Box>
    );
}
